export default {
  QHLX: {type: 'xzqh_qhlx', name: '行政区划'},
  CXFLBZ: {type: 'xzqh_cxfl', name: '城乡分类标识'},

  MLPQZ: {type: 'bzdz_mlpqz', name: '标准地址_门楼牌前缀'},
  MLPHZ: {type: 'bzdz_mlphz', name: '标准地址_门楼牌后缀'},
}
